import { useState } from "react";
import { useRues } from "../hooks/useRues";
import { useNavigate } from "react-router-dom";

import {
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Box,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function ValorAfiliado() {
  const { obtenerValor } = useRues();
  const [nit, setNit] = useState("");
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  const handle = async () => {
    const res = await obtenerValor(nit);
    setData(res);
  };

  return (
    <Card sx={{ p: 3, borderRadius: 3 }}>
      <CardContent>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate("/")}
            variant="outlined"
          >
            Volver al menú principal
          </Button>
        </Box>
        <Typography variant="h5">Valor Afiliado</Typography>

        <TextField
          fullWidth
          label="NIT"
          sx={{ mt: 2 }}
          value={nit}
          onChange={(e) => setNit(e.target.value)}
        />

        <Button variant="contained" sx={{ mt: 2 }} onClick={handle}>
          Consultar
        </Button>

        {data && (
          <div style={{ marginTop: 20 }}>
            <Typography variant="h6">
              💰 ${data.valor.toLocaleString()}
            </Typography>
            <Typography>📊 {data.tamano}</Typography>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
